module.exports = __webpack_public_path__ + "img/donate-bg.47cc7dc1.jpg";